<div class="container">
        <div class="row">
           <div class="col-sm-12">
            <p class="textSearch">Recherche : Résultats trouvés pour "Salle de bain"</p>
           </div>
        </div>
        <div class="row formSearch">
            <div class="col-sm-12">
             <div class="input-group">
                 <div class="form-outline">
                   <input id="search-focus" type="search" id="form1" class="form-control" value="Salle de bain"/>
                 </div>
                 <button type="button" class="btn btn-primary">
                   <i class="fa fa-search"></i>
                 </button>
               </div>
            </div>
         </div>
         <div class="separTitressearchres"></div>
  <!--products list-->
        <div class="row">
            <div class="col-sm-12">
                <div class="container">
                  <div class="row">
                    <div class="col-sm-3">
                      <div class="newProductContainer">
                        <a href="#" class="ProductImgContainer">
                          <img src="assets/front/images/BRAS_DE_DOUCHE__POMME_CHROME_2@2x.png" class="img-fluid ProductImg" />
                        </a>
                        <div class="productData">
                          <div class="productIcons text-center">
                            <a href="#" class="likeAction productActions">
                              <span class="fa-stack fa-lg">
                                <i class="fa fa-circle fa-stack-2x"></i>
                                <i class="fa fa-heart fa-stack-1x fa-inverse"></i>
                              </span>
                            </a>
                            <a href="#" class="viewAction productActions">
                              <span class="fa-stack fa-lg">
                                <i class="fa fa-circle fa-stack-2x"></i>
                                <i class="fa fa-eye fa-stack-1x fa-inverse"></i>
                              </span>
                            </a>
                            <a href="#" class="addtocartAction productActions">
                              <div class="viewAction">
                                <span class="fa-stack fa-lg">
                                  <i class="fa fa-circle fa-stack-2x"></i>
                                  <i class="fa fa-shopping-cart fa-eye fa-stack-1x fa-inverse"></i>
                                </span>
                              </div>
                            </a>
                          </div>
                          <a href="#" class="productDetails">
                            <div class="productTitle text-center">
                              Bras De Douche + Pomme Chrome 26088001 Ntempesta
                            </div>
                            <div class="productPrice text-center">
                              <strong>180</strong> MAD
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-3">
                      <div class="newProductContainer">
                        <a href="#" class="ProductImgContainer">
                          <img src="assets/front/images/BRAS_DE_DOUCHE__POMME_CHROME_2@2x.png" class="img-fluid ProductImg" />
                        </a>
                        <div class="productData">
                          <div class="productIcons text-center">
                            <a href="#" class="likeAction productActions">
                              <span class="fa-stack fa-lg">
                                <i class="fa fa-circle fa-stack-2x"></i>
                                <i class="fa fa-heart fa-stack-1x fa-inverse"></i>
                              </span>
                            </a>
                            <a href="#" class="viewAction productActions">
                              <span class="fa-stack fa-lg">
                                <i class="fa fa-circle fa-stack-2x"></i>
                                <i class="fa fa-eye fa-stack-1x fa-inverse"></i>
                              </span>
                            </a>
                            <a href="#" class="addtocartAction productActions">
                              <div class="viewAction">
                                <span class="fa-stack fa-lg">
                                  <i class="fa fa-circle fa-stack-2x"></i>
                                  <i class="fa fa-shopping-cart fa-eye fa-stack-1x fa-inverse"></i>
                                </span>
                              </div>
                            </a>
                          </div>
                          <a href="#" class="productDetails">
                            <div class="productTitle text-center">
                              Bras De Douche + Pomme Chrome 26088001 Ntempesta
                            </div>
                            <div class="productPrice text-center">
                              <strong>180</strong> MAD
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-3">
                      <div class="newProductContainer">
                        <a href="#" class="ProductImgContainer">
                          <img src="assets/front/images/BRAS_DE_DOUCHE__POMME_CHROME_2@2x.png" class="img-fluid ProductImg" />
                        </a>
                        <div class="productData">
                          <div class="productIcons text-center">
                            <a href="#" class="likeAction productActions">
                              <span class="fa-stack fa-lg">
                                <i class="fa fa-circle fa-stack-2x"></i>
                                <i class="fa fa-heart fa-stack-1x fa-inverse"></i>
                              </span>
                            </a>
                            <a href="#" class="viewAction productActions">
                              <span class="fa-stack fa-lg">
                                <i class="fa fa-circle fa-stack-2x"></i>
                                <i class="fa fa-eye fa-stack-1x fa-inverse"></i>
                              </span>
                            </a>
                            <a href="#" class="addtocartAction productActions">
                              <div class="viewAction">
                                <span class="fa-stack fa-lg">
                                  <i class="fa fa-circle fa-stack-2x"></i>
                                  <i class="fa fa-shopping-cart fa-eye fa-stack-1x fa-inverse"></i>
                                </span>
                              </div>
                            </a>
                          </div>
                          <a href="#" class="productDetails">
                            <div class="productTitle text-center">
                              Bras De Douche + Pomme Chrome 26088001 Ntempesta
                            </div>
                            <div class="productPrice text-center">
                              <strong>180</strong> MAD
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="newProductContainer">
                          <a href="#" class="ProductImgContainer">
                            <img src="assets/front/images/BRAS_DE_DOUCHE__POMME_CHROME_2@2x.png" class="img-fluid ProductImg" />
                          </a>
                          <div class="productData">
                            <div class="productIcons text-center">
                              <a href="#" class="likeAction productActions">
                                <span class="fa-stack fa-lg">
                                  <i class="fa fa-circle fa-stack-2x"></i>
                                  <i class="fa fa-heart fa-stack-1x fa-inverse"></i>
                                </span>
                              </a>
                              <a href="#" class="viewAction productActions">
                                <span class="fa-stack fa-lg">
                                  <i class="fa fa-circle fa-stack-2x"></i>
                                  <i class="fa fa-eye fa-stack-1x fa-inverse"></i>
                                </span>
                              </a>
                              <a href="#" class="addtocartAction productActions">
                                <div class="viewAction">
                                  <span class="fa-stack fa-lg">
                                    <i class="fa fa-circle fa-stack-2x"></i>
                                    <i class="fa fa-shopping-cart fa-eye fa-stack-1x fa-inverse"></i>
                                  </span>
                                </div>
                              </a>
                            </div>
                            <a href="#" class="productDetails">
                              <div class="productTitle text-center">
                                Bras De Douche + Pomme Chrome 26088001 Ntempesta
                              </div>
                              <div class="productPrice text-center">
                                <strong>180</strong> MAD
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    <div class="col-sm-3">
                      <div class="newProductContainer">
                        <a href="#" class="ProductImgContainer">
                          <img src="assets/front/images/BRAS_DE_DOUCHE__POMME_CHROME_2@2x.png" class="img-fluid ProductImg" />
                        </a>
                        <div class="productData">
                          <div class="productIcons text-center">
                            <a href="#" class="likeAction productActions">
                              <span class="fa-stack fa-lg">
                                <i class="fa fa-circle fa-stack-2x"></i>
                                <i class="fa fa-heart fa-stack-1x fa-inverse"></i>
                              </span>
                            </a>
                            <a href="#" class="viewAction productActions">
                              <span class="fa-stack fa-lg">
                                <i class="fa fa-circle fa-stack-2x"></i>
                                <i class="fa fa-eye fa-stack-1x fa-inverse"></i>
                              </span>
                            </a>
                            <a href="#" class="addtocartAction productActions">
                              <div class="viewAction">
                                <span class="fa-stack fa-lg">
                                  <i class="fa fa-circle fa-stack-2x"></i>
                                  <i class="fa fa-shopping-cart fa-eye fa-stack-1x fa-inverse"></i>
                                </span>
                              </div>
                            </a>
                          </div>
                          <a href="#" class="productDetails">
                            <div class="productTitle text-center">
                              Bras De Douche + Pomme Chrome 26088001 Ntempesta
                            </div>
                            <div class="productPrice text-center">
                              <strong>180</strong> MAD
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-3">
                      <div class="newProductContainer">
                        <a href="#" class="ProductImgContainer">
                          <img src="assets/front/images/BRAS_DE_DOUCHE__POMME_CHROME_2@2x.png" class="img-fluid ProductImg" />
                        </a>
                        <div class="productData">
                          <div class="productIcons text-center">
                            <a href="#" class="likeAction productActions">
                              <span class="fa-stack fa-lg">
                                <i class="fa fa-circle fa-stack-2x"></i>
                                <i class="fa fa-heart fa-stack-1x fa-inverse"></i>
                              </span>
                            </a>
                            <a href="#" class="viewAction productActions">
                              <span class="fa-stack fa-lg">
                                <i class="fa fa-circle fa-stack-2x"></i>
                                <i class="fa fa-eye fa-stack-1x fa-inverse"></i>
                              </span>
                            </a>
                            <a href="#" class="addtocartAction productActions">
                              <div class="viewAction">
                                <span class="fa-stack fa-lg">
                                  <i class="fa fa-circle fa-stack-2x"></i>
                                  <i class="fa fa-shopping-cart fa-eye fa-stack-1x fa-inverse"></i>
                                </span>
                              </div>
                            </a>
                          </div>
                          <a href="#" class="productDetails">
                            <div class="productTitle text-center">
                              Bras De Douche + Pomme Chrome 26088001 Ntempesta
                            </div>
                            <div class="productPrice text-center">
                              <strong>180</strong> MAD
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-3">
                      <div class="newProductContainer">
                        <a href="#" class="ProductImgContainer">
                          <img src="assets/front/images/BRAS_DE_DOUCHE__POMME_CHROME_2@2x.png" class="img-fluid ProductImg" />
                        </a>
                        <div class="productData">
                          <div class="productIcons text-center">
                            <a href="#" class="likeAction productActions">
                              <span class="fa-stack fa-lg">
                                <i class="fa fa-circle fa-stack-2x"></i>
                                <i class="fa fa-heart fa-stack-1x fa-inverse"></i>
                              </span>
                            </a>
                            <a href="#" class="viewAction productActions">
                              <span class="fa-stack fa-lg">
                                <i class="fa fa-circle fa-stack-2x"></i>
                                <i class="fa fa-eye fa-stack-1x fa-inverse"></i>
                              </span>
                            </a>
                            <a href="#" class="addtocartAction productActions">
                              <div class="viewAction">
                                <span class="fa-stack fa-lg">
                                  <i class="fa fa-circle fa-stack-2x"></i>
                                  <i class="fa fa-shopping-cart fa-eye fa-stack-1x fa-inverse"></i>
                                </span>
                              </div>
                            </a>
                          </div>
                          <a href="#" class="productDetails">
                            <div class="productTitle text-center">
                              Bras De Douche + Pomme Chrome 26088001 Ntempesta
                            </div>
                            <div class="productPrice text-center">
                              <strong>180</strong> MAD
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="newProductContainer">
                          <a href="#" class="ProductImgContainer">
                            <img src="assets/front/images/BRAS_DE_DOUCHE__POMME_CHROME_2@2x.png" class="img-fluid ProductImg" />
                          </a>
                          <div class="productData">
                            <div class="productIcons text-center">
                              <a href="#" class="likeAction productActions">
                                <span class="fa-stack fa-lg">
                                  <i class="fa fa-circle fa-stack-2x"></i>
                                  <i class="fa fa-heart fa-stack-1x fa-inverse"></i>
                                </span>
                              </a>
                              <a href="#" class="viewAction productActions">
                                <span class="fa-stack fa-lg">
                                  <i class="fa fa-circle fa-stack-2x"></i>
                                  <i class="fa fa-eye fa-stack-1x fa-inverse"></i>
                                </span>
                              </a>
                              <a href="#" class="addtocartAction productActions">
                                <div class="viewAction">
                                  <span class="fa-stack fa-lg">
                                    <i class="fa fa-circle fa-stack-2x"></i>
                                    <i class="fa fa-shopping-cart fa-eye fa-stack-1x fa-inverse"></i>
                                  </span>
                                </div>
                              </a>
                            </div>
                            <a href="#" class="productDetails">
                              <div class="productTitle text-center">
                                Bras De Douche + Pomme Chrome 26088001 Ntempesta
                              </div>
                              <div class="productPrice text-center">
                                <strong>180</strong> MAD
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    <div class="col-sm-3">
                      <div class="newProductContainer">
                        <a href="#" class="ProductImgContainer">
                          <img src="assets/front/images/BRAS_DE_DOUCHE__POMME_CHROME_2@2x.png" class="img-fluid ProductImg" />
                        </a>
                        <div class="productData">
                          <div class="productIcons text-center">
                            <a href="#" class="likeAction productActions">
                              <span class="fa-stack fa-lg">
                                <i class="fa fa-circle fa-stack-2x"></i>
                                <i class="fa fa-heart fa-stack-1x fa-inverse"></i>
                              </span>
                            </a>
                            <a href="#" class="viewAction productActions">
                              <span class="fa-stack fa-lg">
                                <i class="fa fa-circle fa-stack-2x"></i>
                                <i class="fa fa-eye fa-stack-1x fa-inverse"></i>
                              </span>
                            </a>
                            <a href="#" class="addtocartAction productActions">
                              <div class="viewAction">
                                <span class="fa-stack fa-lg">
                                  <i class="fa fa-circle fa-stack-2x"></i>
                                  <i class="fa fa-shopping-cart fa-eye fa-stack-1x fa-inverse"></i>
                                </span>
                              </div>
                            </a>
                          </div>
                          <a href="#" class="productDetails">
                            <div class="productTitle text-center">
                              Bras De Douche + Pomme Chrome 26088001 Ntempesta
                            </div>
                            <div class="productPrice text-center">
                              <strong>180</strong> MAD
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-3">
                      <div class="newProductContainer">
                        <a href="#" class="ProductImgContainer">
                          <img src="assets/front/images/BRAS_DE_DOUCHE__POMME_CHROME_2@2x.png" class="img-fluid ProductImg" />
                        </a>
                        <div class="productData">
                          <div class="productIcons text-center">
                            <a href="#" class="likeAction productActions">
                              <span class="fa-stack fa-lg">
                                <i class="fa fa-circle fa-stack-2x"></i>
                                <i class="fa fa-heart fa-stack-1x fa-inverse"></i>
                              </span>
                            </a>
                            <a href="#" class="viewAction productActions">
                              <span class="fa-stack fa-lg">
                                <i class="fa fa-circle fa-stack-2x"></i>
                                <i class="fa fa-eye fa-stack-1x fa-inverse"></i>
                              </span>
                            </a>
                            <a href="#" class="addtocartAction productActions">
                              <div class="viewAction">
                                <span class="fa-stack fa-lg">
                                  <i class="fa fa-circle fa-stack-2x"></i>
                                  <i class="fa fa-shopping-cart fa-eye fa-stack-1x fa-inverse"></i>
                                </span>
                              </div>
                            </a>
                          </div>
                          <a href="#" class="productDetails">
                            <div class="productTitle text-center">
                              Bras De Douche + Pomme Chrome 26088001 Ntempesta
                            </div>
                            <div class="productPrice text-center">
                              <strong>180</strong> MAD
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-3">
                      <div class="newProductContainer">
                        <a href="#" class="ProductImgContainer">
                          <img src="assets/front/images/BRAS_DE_DOUCHE__POMME_CHROME_2@2x.png" class="img-fluid ProductImg" />
                        </a>
                        <div class="productData">
                          <div class="productIcons text-center">
                            <a href="#" class="likeAction productActions">
                              <span class="fa-stack fa-lg">
                                <i class="fa fa-circle fa-stack-2x"></i>
                                <i class="fa fa-heart fa-stack-1x fa-inverse"></i>
                              </span>
                            </a>
                            <a href="#" class="viewAction productActions">
                              <span class="fa-stack fa-lg">
                                <i class="fa fa-circle fa-stack-2x"></i>
                                <i class="fa fa-eye fa-stack-1x fa-inverse"></i>
                              </span>
                            </a>
                            <a href="#" class="addtocartAction productActions">
                              <div class="viewAction">
                                <span class="fa-stack fa-lg">
                                  <i class="fa fa-circle fa-stack-2x"></i>
                                  <i class="fa fa-shopping-cart fa-eye fa-stack-1x fa-inverse"></i>
                                </span>
                              </div>
                            </a>
                          </div>
                          <a href="#" class="productDetails">
                            <div class="productTitle text-center">
                              Bras De Douche + Pomme Chrome 26088001 Ntempesta
                            </div>
                            <div class="productPrice text-center">
                              <strong>180</strong> MAD
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-3">
                      <div class="newProductContainer">
                        <a href="#" class="ProductImgContainer">
                          <img src="assets/front/images/BRAS_DE_DOUCHE__POMME_CHROME_2@2x.png" class="img-fluid ProductImg" />
                        </a>
                        <div class="productData">
                          <div class="productIcons text-center">
                            <a href="#" class="likeAction productActions">
                              <span class="fa-stack fa-lg">
                                <i class="fa fa-circle fa-stack-2x"></i>
                                <i class="fa fa-heart fa-stack-1x fa-inverse"></i>
                              </span>
                            </a>
                            <a href="#" class="viewAction productActions">
                              <span class="fa-stack fa-lg">
                                <i class="fa fa-circle fa-stack-2x"></i>
                                <i class="fa fa-eye fa-stack-1x fa-inverse"></i>
                              </span>
                            </a>
                            <a href="#" class="addtocartAction productActions">
                              <div class="viewAction">
                                <span class="fa-stack fa-lg">
                                  <i class="fa fa-circle fa-stack-2x"></i>
                                  <i class="fa fa-shopping-cart fa-eye fa-stack-1x fa-inverse"></i>
                                </span>
                              </div>
                            </a>
                          </div>
                          <a href="#" class="productDetails">
                            <div class="productTitle text-center">
                              Bras De Douche + Pomme Chrome 26088001 Ntempesta
                            </div>
                            <div class="productPrice text-center">
                              <strong>180</strong> MAD
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="newProductContainer">
                          <a href="#" class="ProductImgContainer">
                            <img src="assets/front/images/BRAS_DE_DOUCHE__POMME_CHROME_2@2x.png" class="img-fluid ProductImg" />
                          </a>
                          <div class="productData">
                            <div class="productIcons text-center">
                              <a href="#" class="likeAction productActions">
                                <span class="fa-stack fa-lg">
                                  <i class="fa fa-circle fa-stack-2x"></i>
                                  <i class="fa fa-heart fa-stack-1x fa-inverse"></i>
                                </span>
                              </a>
                              <a href="#" class="viewAction productActions">
                                <span class="fa-stack fa-lg">
                                  <i class="fa fa-circle fa-stack-2x"></i>
                                  <i class="fa fa-eye fa-stack-1x fa-inverse"></i>
                                </span>
                              </a>
                              <a href="#" class="addtocartAction productActions">
                                <div class="viewAction">
                                  <span class="fa-stack fa-lg">
                                    <i class="fa fa-circle fa-stack-2x"></i>
                                    <i class="fa fa-shopping-cart fa-eye fa-stack-1x fa-inverse"></i>
                                  </span>
                                </div>
                              </a>
                            </div>
                            <a href="#" class="productDetails">
                              <div class="productTitle text-center">
                                Bras De Douche + Pomme Chrome 26088001 Ntempesta
                              </div>
                              <div class="productPrice text-center">
                                <strong>180</strong> MAD
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    <div class="col-sm-3">
                      <div class="newProductContainer">
                        <a href="#" class="ProductImgContainer">
                          <img src="assets/front/images/BRAS_DE_DOUCHE__POMME_CHROME_2@2x.png" class="img-fluid ProductImg" />
                        </a>
                        <div class="productData">
                          <div class="productIcons text-center">
                            <a href="#" class="likeAction productActions">
                              <span class="fa-stack fa-lg">
                                <i class="fa fa-circle fa-stack-2x"></i>
                                <i class="fa fa-heart fa-stack-1x fa-inverse"></i>
                              </span>
                            </a>
                            <a href="#" class="viewAction productActions">
                              <span class="fa-stack fa-lg">
                                <i class="fa fa-circle fa-stack-2x"></i>
                                <i class="fa fa-eye fa-stack-1x fa-inverse"></i>
                              </span>
                            </a>
                            <a href="#" class="addtocartAction productActions">
                              <div class="viewAction">
                                <span class="fa-stack fa-lg">
                                  <i class="fa fa-circle fa-stack-2x"></i>
                                  <i class="fa fa-shopping-cart fa-eye fa-stack-1x fa-inverse"></i>
                                </span>
                              </div>
                            </a>
                          </div>
                          <a href="#" class="productDetails">
                            <div class="productTitle text-center">
                              Bras De Douche + Pomme Chrome 26088001 Ntempesta
                            </div>
                            <div class="productPrice text-center">
                              <strong>180</strong> MAD
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-3">
                      <div class="newProductContainer">
                        <a href="#" class="ProductImgContainer">
                          <img src="assets/front/images/BRAS_DE_DOUCHE__POMME_CHROME_2@2x.png" class="img-fluid ProductImg" />
                        </a>
                        <div class="productData">
                          <div class="productIcons text-center">
                            <a href="#" class="likeAction productActions">
                              <span class="fa-stack fa-lg">
                                <i class="fa fa-circle fa-stack-2x"></i>
                                <i class="fa fa-heart fa-stack-1x fa-inverse"></i>
                              </span>
                            </a>
                            <a href="#" class="viewAction productActions">
                              <span class="fa-stack fa-lg">
                                <i class="fa fa-circle fa-stack-2x"></i>
                                <i class="fa fa-eye fa-stack-1x fa-inverse"></i>
                              </span>
                            </a>
                            <a href="#" class="addtocartAction productActions">
                              <div class="viewAction">
                                <span class="fa-stack fa-lg">
                                  <i class="fa fa-circle fa-stack-2x"></i>
                                  <i class="fa fa-shopping-cart fa-eye fa-stack-1x fa-inverse"></i>
                                </span>
                              </div>
                            </a>
                          </div>
                          <a href="#" class="productDetails">
                            <div class="productTitle text-center">
                              Bras De Douche + Pomme Chrome 26088001 Ntempesta
                            </div>
                            <div class="productPrice text-center">
                              <strong>180</strong> MAD
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="newProductContainer">
                          <a href="#" class="ProductImgContainer">
                            <img src="assets/front/images/BRAS_DE_DOUCHE__POMME_CHROME_2@2x.png" class="img-fluid ProductImg" />
                          </a>
                          <div class="productData">
                            <div class="productIcons text-center">
                              <a href="#" class="likeAction productActions">
                                <span class="fa-stack fa-lg">
                                  <i class="fa fa-circle fa-stack-2x"></i>
                                  <i class="fa fa-heart fa-stack-1x fa-inverse"></i>
                                </span>
                              </a>
                              <a href="#" class="viewAction productActions">
                                <span class="fa-stack fa-lg">
                                  <i class="fa fa-circle fa-stack-2x"></i>
                                  <i class="fa fa-eye fa-stack-1x fa-inverse"></i>
                                </span>
                              </a>
                              <a href="#" class="addtocartAction productActions">
                                <div class="viewAction">
                                  <span class="fa-stack fa-lg">
                                    <i class="fa fa-circle fa-stack-2x"></i>
                                    <i class="fa fa-shopping-cart fa-eye fa-stack-1x fa-inverse"></i>
                                  </span>
                                </div>
                              </a>
                            </div>
                            <a href="#" class="productDetails">
                              <div class="productTitle text-center">
                                Bras De Douche + Pomme Chrome 26088001 Ntempesta
                              </div>
                              <div class="productPrice text-center">
                                <strong>180</strong> MAD
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
              </div>
           </div>
        </div>
        <div class="row">
            <div class="col-sm-12 text-center">
                <nav aria-label="Page navigation example">
                  <ul class="pagination justify-content-center">
                    <li class="page-item disabled">
                      <a class="page-link" href="#" tabindex="-1" aria-disabled="true">Previous</a>
                    </li>
                    <li class="page-item active"><a class="page-link" href="#">1</a></li>
                    <li class="page-item"><a class="page-link" href="#">2</a></li>
                    <li class="page-item"><a class="page-link" href="#">3</a></li>
                    <li class="page-item">
                      <a class="page-link" href="#">Next</a>
                    </li>
                  </ul>
                </nav>
              </div>
        </div>
      </div>
